<a class="no-styl"  *ngFor="let userLink of userLinks"
 mat-menu-item (click)="OnUserLink(userLink.URL)"
 target="_blank">{{userLink.Title}}</a>
 <mat-divider *ngIf="userLinks?.length"></mat-divider>
